export default __webpack_public_path__ + "static/media/participants_not_found.e83143c7.svg";